import type { FC, HTMLAttributes } from "react";

import styles from "./_.module.css";

import { useFocusState } from "../useFocusState";

export type InputSwitchProps = {
	checked: boolean;
	variant?: "md" | "sm" | "xs" | "xxs" | undefined;
	onChange?: (arg: boolean) => any;
	id?: string;
};

type Props = InputSwitchProps & HTMLAttributes<HTMLInputElement>;

export const InputSwitch: FC<Props> = ({ checked, onChange, variant, id }) => {
	const [isFocused, focusProps] = useFocusState();

	const clickHandler = (e: any) => {
		onChange?.(e.target.checked);
	};

	return (
		<div
			className={[
				styles["input-switch"],
				variant && styles[variant],
				isFocused && styles["focused"],
				checked && styles["checked"],
			].join(" ")}
		>
			<input
				id={id}
				type="checkbox"
				checked={checked}
				onChange={clickHandler}
				aria-label={"toggle value"}
				{...focusProps}
			/>
			<div aria-hidden></div>
		</div>
	);
};
